import { Status } from "../../DataFrame";
import { IDIService } from "../../IDIService";
import { ResponseResult } from "../FieldChangeResult";

export interface IConnectedAppsService extends IDIService {
	IsSupportedAsync(): Promise<boolean>;
	GetConnectedAppsAsync(): Promise<Status | ConnectedApp[]>;
	UpsertConnectedAppAsync(app: ConnectedApp): Promise<ResponseResult<UpsertConnectedAppResult>>;
	RemoveConnectedAppAsync(app: ConnectedApp): Promise<Status>;
}

export enum UpsertConnectedAppResult
{
	ResourceIsNotAvailable = -11,
	AnotherAppWithGivenAccessTokenAlreadyExists = -10,
	AppGuidDoesNotExists = -7,
	AppUrlToShort = -6,
	AppUserNameToShort = -5,
	AppUserIdToShort = -4,
	AccessTokenToShort = -3,
	AppNameToShort = -2,
	UnkownError = 0,
	Changed = 1,
}

export class ConnectedApp {
	public Guid: string = "";
	public AppName: string = "";
	public AppUrl: string = "";
	public AccessToken: string = "";
	public IsAccessEnabled: boolean = false;
	public AppUserName: string = "";
	public AppUserId: string = "";
}